interface FormatCurrencyOptions {
  minimumFractionDigits?: number;
  maximumFractionDigits?: number;
  showCurrencySign?: boolean;
}

export const formatCurrency = (value?: number | null, options: FormatCurrencyOptions = {}): string => {
  const { minimumFractionDigits = 2, maximumFractionDigits = 2, showCurrencySign = true } = options;

  if (value == null) return '-';

  const formattedValue = value.toLocaleString('en-GB', {
    minimumFractionDigits,
    maximumFractionDigits
  });

  return showCurrencySign ? `£ ${formattedValue}` : formattedValue;
};
